<template>

    <div v-if="dataStore.showWolcomeWindow" v-on:click="hide($event)" :class="project.welcome_mode === 'END' ? 'ended' : ''" id="popup-information" class="popup-information">

        <div>

            <div class="container">

                <div class="row">

                    <div class="col-12">

                        <span class="close-popup" v-on:click="showWelcomeInfo()"><i class="fas fa-times"></i></span>

                        <h3 v-if="!dataStore.showShareLink">{{ project.welcome_mode === 'END' ? language.thank_you : language.welcome + '!' }}</h3>

                        <h3 v-if="dataStore.showShareLink">{{ language.share_dialogue }}</h3>

                        <div v-if="!dataStore.showShareLink" class="information">
                            <div v-if="project.welcome_mode === 'BEFORE'" v-html="project.before_text"></div>
                            <div v-if="project.welcome_mode === 'DEFAULT'" v-html="project.welcome_text"></div>
                            <div v-if="project.welcome_mode === 'END'" v-html="project.end_text"></div>
                        </div>

                        <fragment v-if="!project.scheduled">

                            <div class="button-wrap" v-if="currentUrl !== geturl">
                                <a :title="language.start" v-if="!dataStore.showShareLink" class="btn btn-primary" v-on:click="showWelcomeInfo()">{{ language.start }}</a>
                            </div>

                            <div class="button-wrap" v-else>
                                <a :title="language.start " v-if="project.welcome_mode !== 'END' && !dataStore.showShareLink" class="btn btn-primary" v-on:click.prevent="goToLink(addurl)">{{ language.start }}</a>
                            </div>

                        </fragment>




                        
                        <a :title="language.view_comments" v-if="!dataStore.showShareLink" class="underline" :class="{ 'review-answers' : ( project.welcome_mode === 'END' && currentUrl === addurl) }" v-on:click.prevent="currentUrl !== geturl ? goToLink(geturl) : showWelcomeInfo()">{{ language.view_comments }}</a>

                        <a :title="language.more_info" v-if="dataStore.addLink && showLink && !dataStore.showShareLink" class="underline" target="_blank" :href="project.link">{{ language.more_info }}</a>
                        
                        <a :title="language.find_place" v-if="project.map_link && showMapLink && !project.hide_map_link && !dataStore.showShareLink" class="underline" target="_blank" :href="project.map_link">{{ language.find_place }}</a>

                        <a :title="language.faq" v-if="project.allow_faq && !dataStore.showShareLink" class="underline" :href="mainUrl + '/' + project.slug + '/faq'">{{ language.faq }}</a>

                        <a :title="language.share" v-if="project.hide_share" class="underline" href="#" v-on:click.prevent="copyText()">{{ language.share }}</a>

                        <p v-if="copytext && project.hide_share" class="copy-text-welcome">{{copytext}}</p>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>


<script>

import dataStore from "../../store";

import { Fragment } from 'vue-fragment'

export default {

    components : { Fragment },

    data() {
        return {
            dataStore,
            todayDate : new Date(),
            showLink : false,
            showMapLink : false,
            copytext : ''
        };
    },

    inject: [ 'language' ],

    computed : {

        mainUrl: function() {
            return window.location.origin
        },

        sessionName: function() {
            return `welcome-info-show-${this.project.slug}`
        }

    },

    mounted() {

        if( sessionStorage.getItem(this.sessionName) ) {
            this.dataStore.showWolcomeWindow = false
        }

        if( window.location.search.includes('hide_welcome=true') ) {
            window.history.pushState('', document.title, window.location.pathname )
            this.dataStore.showWolcomeWindow = false
        }

        if(this.project.link !== null) {
            this.showLink = true
        }

        if(this.project.map_link !== null) {
            this.showMapLink = true
        }

    },

    props: {
        project : Object,
        currentUrl : String,
        geturl : String,
        addurl : String,
    },

    methods: {

        goToLink: function(link) {
            sessionStorage.setItem(this.sessionName, false)
            window.location.href = link + '?hide_welcome=true'
        },

        showWelcomeInfo: function (link = null) {
            sessionStorage.setItem(this.sessionName, false)
            this.dataStore.showWolcomeWindow = !this.dataStore.showWolcomeWindow;
            this.dataStore.addLink = link === 'link' ? true : false;
        },

        hide: function(e){

            if( e.srcElement.className.includes('popup-information') ){
                this.dataStore.showWolcomeWindow = false;
                sessionStorage.setItem(this.sessionName, false)
            }

        },

        copyText: function() {
            this.copyStringToClipboard(this.geturl);
        },

        copyStringToClipboard: function (str) {

            try {
                // Create new element
                var el = document.createElement('textarea');
                // Set value (string to be copied)
                el.value = str;
                // Set non-editable to avoid focus and move outside of view
                el.setAttribute('readonly', '');
                el.style = {position: 'absolute', left: '-9999px'};
                document.body.appendChild(el);
                // Select text inside element
                el.select();
                // Copy text to clipboard
                document.execCommand('copy');
                // Remove temporary element
                document.body.removeChild(el);

                this.copytext = this.language.link_copied;

            } catch (error) {
                this.copytext = this.language.something_went_wrong;
            }

            setTimeout(() => { this.copytext = '' }, 3000);

        },
    }
};

</script>

